import { DynamicLoad } from '@/_cactus_core/build/dynamicLoad';





import acc00a25403861d73b227c99e95ef0dd2b from "./generated-48cb95be-74ef-4c2d-bee7-400899431092.json";

import af4b7db4ce760c14c2253fd9c95fd68b7b from "./generated-d6653f53-f36a-4688-8e66-68c0529d9a90.json";

import a3fbe496d2ce2f1cddbb079bb40f18619b from "./generated-1e7c50c9-d7ea-4cbb-bbc3-b2dbdc9a98da.json";

import a0a6972ad9e1b0ecb4cd6ca3ab81412eab from "./generated-8c09da31-69c0-4fca-83c4-9239c08f4f66.json";

import a83a28fa4d321874048252e2db3788ae4b from "./generated-aed24dc8-af1c-4b1f-8d24-0465df5548e3.json";

import ac35bec8bf7699263832f8b79ef156d3bb from "./generated-1c1a5e0a-429a-475b-a0f7-d934996a5cf7.json";

import a72fba5292ec9e1a346845add030b2c80b from "./generated-ad20d469-1368-4071-bd66-4854fd131f34.json";

import a62ca4afa1c1fde374fbb73dc58de5164b from "./generated-15aebf62-64a4-44af-9cc2-1346004fd0bd.json";

import a659bafeb4320e5b890c5742f5ddecc36b from "./generated-c501aef6-7172-4ae9-82d2-931d33ce4a49.json";

import a1f89446cfcae7b3541aa084cd86994f3b from "./generated-cfac34a2-fb67-4f22-a301-7b57f936c3b9.json";

import a829c96fcbf600623a98d8ff9e05d0040b from "./generated-39cf81da-3375-4da2-b0f0-cd1214c44f00.json";

import a975c8bb9af54ce2362f50b0b99e44752b from "./generated-1b333e12-e14d-4c26-80a4-3d74e954cec0.json";

import a4cbb56532124e99fcce25f99a2af9715b from "./generated-017375fa-14b1-4da5-88d1-2e00b2fbb5d4.json";

import a463d17a6706163464a023d9b786ed692b from "./generated-042217e2-fe75-4520-ba46-06035022a94a.json";

import a101d0404dd9bbd07a9514ca8cc19720ab from "./generated-c74acb28-a4e5-4273-bb46-b8e2f577ee24.json";

import ae0c9b3bb94bde81b73c396e1def3a648b from "./generated-bf40671e-892f-4634-8d4e-1be26c8b2235.json";

import a6db3a7238f001f59baa830af7d87b665b from "./generated-b79667d6-1016-4757-94e1-a4481a2111b4.json";





/* eslint-disable */

export default async function(url) {
  let storeData = false;

  async function direct(jsonResult) {
    return new Promise(async function(done,err) {
      try {
        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };
        
        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }

  async function ok(cachedJson) {
    return new Promise(async function(done,err) {
      try {
        const jsonResult = await DynamicLoad(cachedJson);

        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };

        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }
  
  try {
  
  




         if(url === "/api/appearance"){
            
                    await direct(acc00a25403861d73b227c99e95ef0dd2b);
                
        }
    


        else if(url === "/api/getlegalterm"){
            
                    await direct(af4b7db4ce760c14c2253fd9c95fd68b7b);
                
        }
    


        else if(url === "/api/country"){
            
                    await direct(a3fbe496d2ce2f1cddbb079bb40f18619b);
                
        }
    


        else if(url === "/api/crypto/all"){
            
                    await direct(a0a6972ad9e1b0ecb4cd6ca3ab81412eab);
                
        }
    


        else if(url === "/api/bff/features"){
            
                    await direct(a83a28fa4d321874048252e2db3788ae4b);
                
        }
    


        else if(url === "/api/payment-providers"){
            
                    await direct(ac35bec8bf7699263832f8b79ef156d3bb);
                
        }
    


        else if(url === "/api/bff/games/top-wins"){
            
                    await direct(a72fba5292ec9e1a346845add030b2c80b);
                
        }
    


        else if(url === "/api/bff/games/last-wins"){
            
                    await direct(a62ca4afa1c1fde374fbb73dc58de5164b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-da-pg&per_page=15"){
            
                    await direct(a659bafeb4320e5b890c5742f5ddecc36b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=roleta&per_page=16"){
            
                    await direct(a1f89446cfcae7b3541aa084cd86994f3b);
                
        }
    


        else if(url === "/api/undefined&per_page=undefined"){
            
                    await direct(a829c96fcbf600623a98d8ff9e05d0040b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-crash&per_page=15"){
            
                    await direct(a975c8bb9af54ce2362f50b0b99e44752b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-de-aventura&per_page=15"){
            
                    await direct(a659bafeb4320e5b890c5742f5ddecc36b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=cassino-ao-vivo&per_page=15"){
            
                    await direct(a4cbb56532124e99fcce25f99a2af9715b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=slots&per_page=15"){
            
                    await direct(a463d17a6706163464a023d9b786ed692b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-novos&per_page=15"){
            
                    await direct(a659bafeb4320e5b890c5742f5ddecc36b);
                
        }
    


        else if(url === "/api/casino-games/filter?per_page=1&per_page=15"){
            
                    await direct(a101d0404dd9bbd07a9514ca8cc19720ab);
                
        }
    


        else if(url === "/api/casino-games/filter?providers[]=hacksaw&per_page=15"){
            
                    await direct(ae0c9b3bb94bde81b73c396e1def3a648b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=blackjack&per_page=15"){
            
                    await direct(a6db3a7238f001f59baa830af7d87b665b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories%5B%5D=all"){
            
                    await direct(a101d0404dd9bbd07a9514ca8cc19720ab);
                
        }
    





  } catch(ex){
    console.log('failed to get cache',ex,url);
  }

  return storeData;
};

/* eslint-enable */